import { render, staticRenderFns } from "./DocumentFile.vue?vue&type=template&id=5b3d29f2&scoped=true"
import script from "./DocumentFile.vue?vue&type=script&lang=js"
export * from "./DocumentFile.vue?vue&type=script&lang=js"
import style0 from "./DocumentFile.vue?vue&type=style&index=0&id=5b3d29f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3d29f2",
  null
  
)

export default component.exports